import React from "react";

const MainContext = React.createContext({
    pageTitle: <></>,
    setTitle: (title: JSX.Element) => {},
});

export default MainContext;